export enum PptFields {
    SIZE = "Size",
    LIGHT = "Light",
    RATE = "Rate for Selected Days",
    AVAILABILITY = "Availability",
    MONTHLY_RATE = "Monthly Rate"
}